import LoadingTable from "@/components/LoadingTable";
import { PerformanceRateInterface } from "@/components/PerformanceRate/PerformanceRate.interface";
import { Table } from "@/components/Table";

import React from "react";

import { orderBy } from "lodash";

export const PerformanceRate: React.FC<PerformanceRateInterface> = ({
  data,
  isLoading,
  sort,
  bestHeading,
  bestCaption,
  worstHeading,
  worstCaption,
  bestColumns,
  worstColumns,
}) => {
  const sortedData = orderBy(data, [(row) => row.rate], sort);
  const firstDataBatch = sortedData.slice(0, 5);
  const lastDataBatch = sortedData.reverse().slice(0, 5);

  return (
    <div className="grid h-full 2xl:grid-cols-2 2xl:divide-x-2">
      <div className="mb-10 h-full 2xl:mb-0 2xl:pr-4">
        <h6 className="font-dm-sans mb-1 text-base font-bold text-black">
          {bestHeading}
        </h6>
        <p className="text-grey6 mb-4 text-sm">{bestCaption}</p>
        {isLoading ? (
          <LoadingTable rows={6} />
        ) : (
          <Table
            columns={bestColumns}
            data={lastDataBatch}
            sortable={false}
            rightAlign
            emptyViewType="noData"
            showHeadersWhenEmpty={false}
            className="grow"
            emptyViewClassName="mt-16"
          />
        )}
      </div>
      <div className="h-full 2xl:pl-4">
        <h6 className="font-dm-sans mb-1 text-base font-bold text-black">
          {worstHeading}
        </h6>
        <p className="text-grey6 mb-4 text-sm">{worstCaption}</p>
        {isLoading ? (
          <LoadingTable rows={6} />
        ) : (
          <Table
            columns={worstColumns}
            data={firstDataBatch}
            sortable={false}
            rightAlign
            emptyViewType="noData"
            showHeadersWhenEmpty={false}
            className="grow"
            emptyViewClassName="mt-16"
          />
        )}
      </div>
    </div>
  );
};

export default PerformanceRate;
